import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { filter } from 'lodash';

import MobileNavItem from '~/components/footer/MobileNavItem';
import BottomMobileFooter from '~/components/footer/BottomMobileFooter';

import { mobileOnly, Hiddenh3 } from '~/styles/helpers';

const Wrapper = styled.div`
    ${mobileOnly}
`;

const NavList = styled.ul`
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-top: 30px;
`;

const MobileFooter = ({
    socialLinks = [],
    footerMenuItems = {},
    navRef,
    triggerRef,
    isMenuOpen
}) => (
    <Wrapper>
        {footerMenuItems?.nodes.length ? (
            <nav aria-label="Footer Links">
                <Hiddenh3 id="footerNavigationLabel">
                    Footer Navigation
                </Hiddenh3>
                <NavList aria-labelledby="footerNavigationLabel">
                    {footerMenuItems?.nodes?.length
                        ? filter(
                              footerMenuItems.nodes,
                              ({ footerMenuOptions: { excludeFromMobile } }) =>
                                  !excludeFromMobile
                          ).map((menuItem) => (
                              <MobileNavItem
                                  key={menuItem.id}
                                  {...menuItem}
                                  {...{ socialLinks, navRef, triggerRef }}
                                  mainMenuIsClosed={!isMenuOpen}
                              />
                          ))
                        : null}
                </NavList>
            </nav>
        ) : null}

        <BottomMobileFooter {...{ socialLinks }} />
    </Wrapper>
);

MobileFooter.propTypes = {
    socialLinks: PropTypes.arrayOf(PropTypes.shape({})),
    footerMenuItems: PropTypes.shape({}),
    navRef: PropTypes.shape({}).isRequired,
    triggerRef: PropTypes.shape({}).isRequired,
    isMenuOpen: PropTypes.bool.isRequired
};

export default MobileFooter;
